export const formatDateID = (iso, opts) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("id-ID", opts || { day: "numeric", month: "long", year: "numeric" });
};

export const monthShortID = (iso) => {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("id-ID", { month: "short" }).toUpperCase();
};

export const dayOf = (iso) => {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "--";
  return String(d.getDate()).padStart(2, "0");
};
